import { createAction, props } from '@ngrx/store';
import { IrisDMSFolderI } from '../../models/IrisDMSFolder';
import { IrisPermissionI } from '@iris/common/models/IrisPermission';
import { IrisPermissionGroupI } from '@iris/common/models/IrisPermissionGroup';
import { IrisDmsFolderChangeEventI } from '../../models/dms-folder-change-event.model';

const prefixed = (type): string => `[DmsFolders] ${type}`;

export const CopyFolderError = createAction(
  prefixed('Copy Folder Error'),
);

export const RemoveFolderSuccess = createAction(
  prefixed('Remove Folder Success'),
  props<{ removedFolder: IrisDMSFolderI }>(),
);

export const RemoveFolderError = createAction(
  prefixed('Remove Folder Error'),
);

export const UpdateFolderSuccess = createAction(
  prefixed('Update Folder Success'),
  props<{ folder: IrisDMSFolderI }>(),
);

export const FolderChangeEvent = createAction(
  prefixed('Folder Change Event'),
  props<IrisDmsFolderChangeEventI>(),
);

export const FolderPermissionsChangeEvent = createAction(
  '[DmsFolders] Folder Permissions Change Event',
  props<{ permission: IrisPermissionI; group: IrisPermissionGroupI }>(),
);
